import angular from 'angular';
import indexAliasesTabContent from './index-aliases-tab-content.component';

export default angular.module('eshq.indexAliasesTabContent', [])
  .component('eshqIndexAliasesTabContent', indexAliasesTabContent)
  .name;



// WEBPACK FOOTER //
// ./ui/src/components/index-aliases-tab-content/index-aliases-tab-content.js